module.exports = __webpack_public_path__ + "img/nm_home_header_illustration-mobile.8fa63003.png";